import style from './index.module.scss';
import { ReactComponent as LogoSvg } from './exclamation_mark.svg';

export const ExclamationMark = () => {
  return <LogoSvg className={style.mark} width={30} height={30} />;
};
